import React, { useEffect, useState } from "react";
import userResources from "api/userResources";
import CustomComonent from "./CustomComonent";

export default function SupplierSales() {
  const [supplierData, setSupplierData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getSupplierSales = async () => {
    setIsLoading(true); // Set loading state to true when fetching starts
    try {
      // Use the appropriate supplier sales endpoint
      const response = await userResources.supplier();
      const data = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      setSupplierData(data);
    } catch (error) {
      console.error("Error fetching supplier sales data:", error);
    } finally {
      setIsLoading(false); // Set loading state to false when fetching ends
    }
  };

  useEffect(() => {
    getSupplierSales();
  }, []);

  return (
    <div>
      <CustomComonent
        supplierSales={{
          supplierTrue: true,
          supplierData: supplierData,
          supplierLoading: isLoading,
        }}
      />
    </div>
  );
}
